import { useState } from 'react';
import { ArPaymentLinksView, COLLECTIONS, CreateLinkDrawer } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';

/**
 * Collections › Payment links (amendment 28 §2.3). The team's links and the
 * follow-ups' links together, with Sent by.
 */
export function CollectionsLinksPage() {
  useClearPageTopBarActions();
  const navigate = useNavigate();
  const [linkOpen, setLinkOpen] = useState(false);

  return (
    <>
      <ArPaymentLinksView
        onSelectTab={(tab) => {
          if (tab === 'balances') void navigate('/collections');
          else if (tab === 'follow-ups') void navigate('/collections/follow-ups');
        }}
        onOpenSettings={() => { void navigate('/settings/ai/accounts-receivable'); }}
        onCreateLink={() => { setLinkOpen(true); }}
        onOpenPatient={(patientId) => { void navigate(`/patients/${patientId}/profile`); }}
      />
      <CreateLinkDrawer open={linkOpen} patient={COLLECTIONS.drawerPatient} prefill={null} onClose={() => { setLinkOpen(false); }} />
    </>
  );
}
